<template>
	<div>
	<div class="sidebar-container" v-bind:class="{ 'active': toggleMainSidebar }">

			<!-- Toggle Button (Spark-style) -->
			<div class="toggle-bar" @click="toggleSidebar()">
				<button class="toggle-menu-btn">
					<i class="fa-solid" :class="toggleMainSidebar ? 'fa-chevron-right' : 'fa-chevron-left'"></i>
				</button>
			</div>

			<div class="logo mb-2">
				<img src="@/assets/img/XSurfLog_White.svg" alt="xsurflog_log" class="img-fluid p-4 full-logo" />
				<img src="@/assets/img/X.svg" alt="xsurflog_x" class="collapsed-logo" />
				<hr class="mx-4" style="color: #d9d9d9;" />
			</div>

			<!-- <hr v-show="!toggleMainSidebar" style="padding:0px; margin-left:10px; margin-right:20px;" class="border-white hide-mobile" /> -->
			<div class="navigation">

				<!-- <div class="nav-menu-wrapper">
					<ul class="nav-menu-list nav flex-column">
						<li class="nav-menu-item">
							<router-link to="/dashboard" class="nav-menu-link nav-link">
								<span class="col-3">
									<svg width="25" height="25" viewBox="0 0 28 28" fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<path
											d="M1.82285 0.75H9.63535C10.2266 0.75 10.7084 1.23195 10.7084 1.82285V6.51035C10.7084 7.1015 10.2265 7.5834 9.63535 7.5834H1.82285C1.23195 7.5834 0.75 7.10155 0.75 6.51035V1.82285C0.75 1.23189 1.23189 0.75 1.82285 0.75Z"
											stroke="currentColor" stroke-width="1.5" />
										<path
											d="M1.82285 11.1665H9.63535C10.2265 11.1665 10.7084 11.6484 10.7084 12.2395V23.1771C10.7084 23.768 10.2266 24.2499 9.63535 24.2499H1.82285C1.23189 24.2499 0.75 23.768 0.75 23.1771V12.2395C0.75 11.6483 1.23195 11.1665 1.82285 11.1665Z"
											stroke="currentColor" stroke-width="1.5" />
										<path
											d="M15.3645 17.4165H23.177C23.768 17.4165 24.2499 17.8983 24.2499 18.4895V23.177C24.2499 23.768 23.768 24.2499 23.177 24.2499H15.3645C14.7733 24.2499 14.2915 23.768 14.2915 23.177V18.4895C14.2915 17.8984 14.7734 17.4165 15.3645 17.4165Z"
											stroke="currentColor" stroke-width="1.5" />
										<path
											d="M22.427 0.75H23.177C23.768 0.75 24.2499 1.23189 24.2499 1.82285V12.7604C24.2499 13.3516 23.768 13.8334 23.177 13.8334H15.3645C14.7734 13.8334 14.2915 13.3515 14.2915 12.7604V1.82285C14.2915 1.23194 14.7733 0.75 15.3645 0.75H22.427Z"
											stroke="currentColor" stroke-width="1.5" />
									</svg>
								</span>
								<span>Dashboard</span>
							</router-link>
						</li>

						<li class="nav-menu-item">
							<a class="nav-menu-link nav-link">
								<span class="col-3">
									<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 20 20"
										fill="none">
										<path
											d="M8.95573 12.5C8.86337 12.6953 8.7941 12.8971 8.74792 13.1055C8.70174 13.3138 8.65885 13.5286 8.61927 13.75H2.53333V12.5H8.95573ZM2.53333 16.25V15H8.59948C8.63247 15.2148 8.67865 15.4264 8.73802 15.6348C8.7974 15.8431 8.87326 16.0482 8.96562 16.25H2.53333ZM1.26667 18.75H14.6161L15.8729 20H0V0H11.0339L16.4667 5.36133V10.9082C16.2753 10.7389 16.0741 10.5859 15.863 10.4492C15.6519 10.3125 15.4309 10.1921 15.2 10.0879V6.25H10.1333V1.25H1.26667V18.75ZM11.4 2.13867V5H14.2995L11.4 2.13867ZM11.6375 10C10.9184 10.2669 10.3016 10.6836 9.78698 11.25H2.53333V10H11.6375ZM2.53333 5H8.86667V6.25H2.53333V5ZM13.9333 7.5V8.75H2.53333V7.5H13.9333ZM19 19.375C19 19.5443 18.9373 19.6908 18.812 19.8145C18.6866 19.9382 18.5382 20 18.3667 20C18.1951 20 18.0467 19.9382 17.9214 19.8145L15.0417 16.9824C14.7844 17.1517 14.5073 17.2786 14.2104 17.3633C13.9135 17.4479 13.6101 17.4935 13.3 17.5C12.8646 17.5 12.4556 17.4186 12.0729 17.2559C11.6903 17.0931 11.3538 16.8717 11.0635 16.5918C10.7733 16.3118 10.5457 15.9798 10.3807 15.5957C10.2158 15.2116 10.1333 14.8047 10.1333 14.375C10.1333 13.9453 10.2158 13.5417 10.3807 13.1641C10.5457 12.7865 10.77 12.4577 11.0536 12.1777C11.3373 11.8978 11.6738 11.6732 12.063 11.5039C12.4523 11.3346 12.8646 11.25 13.3 11.25C13.7354 11.25 14.1444 11.3314 14.5271 11.4941C14.9097 11.6569 15.2429 11.8815 15.5266 12.168C15.8102 12.4544 16.0378 12.7865 16.2094 13.1641C16.3809 13.5417 16.4667 13.9453 16.4667 14.375C16.4667 14.681 16.4238 14.9805 16.338 15.2734C16.2523 15.5664 16.1203 15.8398 15.9422 16.0938L18.812 18.9355C18.9373 19.0592 19 19.2057 19 19.375ZM11.4 14.375C11.4 14.6354 11.4495 14.8796 11.5484 15.1074C11.6474 15.3353 11.7826 15.5339 11.9542 15.7031C12.1257 15.8724 12.3269 16.0059 12.5578 16.1035C12.7887 16.2012 13.0361 16.25 13.3 16.25C13.5639 16.25 13.8113 16.2012 14.0422 16.1035C14.2731 16.0059 14.4743 15.8724 14.6458 15.7031C14.8174 15.5339 14.9526 15.3353 15.0516 15.1074C15.1505 14.8796 15.2 14.6354 15.2 14.375C15.2 14.1146 15.1505 13.8704 15.0516 13.6426C14.9526 13.4147 14.8174 13.2161 14.6458 13.0469C14.4743 12.8776 14.2731 12.7441 14.0422 12.6465C13.8113 12.5488 13.5639 12.5 13.3 12.5C13.0361 12.5 12.7887 12.5488 12.5578 12.6465C12.3269 12.7441 12.1257 12.8776 11.9542 13.0469C11.7826 13.2161 11.6474 13.4147 11.5484 13.6426C11.4495 13.8704 11.4 14.1146 11.4 14.375Z"
											fill="currentColor" />
									</svg>
								</span>
								<span class="col-8">Audits</span>
							</a>
						</li>
						<li class="nav-menu-item">
							<router-link to="/catalogue/dashboard" class="nav-menu-link nav-link">
								<span class="col-3">
									<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 20 20"
										fill="none">
										<path
											d="M2.7588 8.771C2.22623 8.771 2.22623 9.60074 2.7588 9.60074C4.8799 9.60074 7.0006 9.60074 9.12154 9.60074C9.65504 9.60074 9.65504 8.771 9.12154 8.771C7.0006 8.771 4.8799 8.771 2.7588 8.771Z"
											fill="currentColor" />
										<path
											d="M9.12154 10.7324C7.0006 10.7324 4.8799 10.7324 2.7588 10.7324C2.22623 10.7324 2.22623 11.5612 2.7588 11.5612C4.8799 11.5612 7.0006 11.5612 9.12154 11.5612C9.65512 11.5612 9.65512 10.7324 9.12154 10.7324Z"
											fill="currentColor" />
										<path
											d="M9.12154 12.5498C7.0006 12.5498 4.8799 12.5498 2.7588 12.5498C2.22623 12.5498 2.22623 13.3785 2.7588 13.3785C4.8799 13.3785 7.0006 13.3785 9.12154 13.3785C9.65512 13.3785 9.65512 12.5498 9.12154 12.5498Z"
											fill="currentColor" />
										<path
											d="M9.12154 14.5112C7.0006 14.5112 4.8799 14.5112 2.7588 14.5112C2.22623 14.5112 2.22623 15.3396 2.7588 15.3396C4.8799 15.3396 7.0006 15.3396 9.12154 15.3396C9.65512 15.3396 9.65512 14.5112 9.12154 14.5112Z"
											fill="currentColor" />
										<path
											d="M8.99962 16.3623C6.8779 16.3623 4.75641 16.3623 2.63571 16.3623C2.10353 16.3623 2.10353 17.191 2.63571 17.191C4.75641 17.191 6.8779 17.191 8.99962 17.191C9.53156 17.191 9.53156 16.3623 8.99962 16.3623Z"
											fill="currentColor" />
										<path
											d="M0 4.52722V20H11.8805V6.6739L9.673 4.52722H0ZM10.8537 18.9698H1.0276V5.55742H9.14417V7.19181H10.8529V18.9698H10.8537Z"
											fill="currentColor" />
										<path
											d="M2.0083 2.15625V3.94714H3.0359V3.18606H11.1529V4.82045H12.862V16.5987H12.4106V17.6288H13.8892V4.30254L11.6817 2.15625H2.0083Z"
											fill="currentColor" />
										<path
											d="M13.7921 0H4.1189V1.79128H5.14611V1.0302H13.2633V2.66459H14.9724V14.4426H14.5214V15.4727H16V2.14668L13.7921 0Z"
											fill="currentColor" />
									</svg>
								</span>
								<span class="col-8">Catalogue</span>
								<span class="col-2 fa-solid fa-arrow-right fa-xl"></span>
							</router-link>

							<div class="sub-menu-wrapper" id="catalogue-sub-menu">
								<ul class="nav flex-column">
									<li class="nav-menu-item">
										<router-link to="/catalogue/controls" class="nav-menu-link nav-link">
											<span class="col-3"></span>
											<span class="col-8">Controls</span>
											
										</router-link>
									</li>
									<li class="nav-menu-item">
										<router-link to="/catalogue/actions" class="nav-menu-link nav-link">
											<span class="col-3"></span>
											<span class="col-8">Actions</span>
											
										</router-link>
									</li>
									<li class="nav-menu-item">
										<router-link to="/catalogue/controlGroups" class="nav-menu-link nav-link">
											<span class="col-3"></span>
											<span class="col-8">Control Groups</span>
										</router-link>
									</li>
									<li v-if="this.$store.state.auth.isSuperAdmin || !this.$store.state.auth.hasOrg"
										class="nav-menu-item">
										<router-link to="/catalogue/auditLogs" class="nav-menu-link nav-link">
											<span class="col-3"></span>
											<span class="col-8">Catalogue Audit Log</span>
										</router-link>
									</li>
								</ul>
							</div>
						</li>
					</ul>
				</div> -->



				<ul class="nav flex-column sidebar-nav main-ul">
					<li class="nav-item" @click="hideSubSidebar()">
						<router-link to="/dashboard" class="nav-link">
							<span class="col-3">
								<svg width="25" height="25" viewBox="0 0 28 28" fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<path
										d="M1.82285 0.75H9.63535C10.2266 0.75 10.7084 1.23195 10.7084 1.82285V6.51035C10.7084 7.1015 10.2265 7.5834 9.63535 7.5834H1.82285C1.23195 7.5834 0.75 7.10155 0.75 6.51035V1.82285C0.75 1.23189 1.23189 0.75 1.82285 0.75Z"
										stroke="currentColor" stroke-width="1.5" />
									<path
										d="M1.82285 11.1665H9.63535C10.2265 11.1665 10.7084 11.6484 10.7084 12.2395V23.1771C10.7084 23.768 10.2266 24.2499 9.63535 24.2499H1.82285C1.23189 24.2499 0.75 23.768 0.75 23.1771V12.2395C0.75 11.6483 1.23195 11.1665 1.82285 11.1665Z"
										stroke="currentColor" stroke-width="1.5" />
									<path
										d="M15.3645 17.4165H23.177C23.768 17.4165 24.2499 17.8983 24.2499 18.4895V23.177C24.2499 23.768 23.768 24.2499 23.177 24.2499H15.3645C14.7733 24.2499 14.2915 23.768 14.2915 23.177V18.4895C14.2915 17.8984 14.7734 17.4165 15.3645 17.4165Z"
										stroke="currentColor" stroke-width="1.5" />
									<path
										d="M22.427 0.75H23.177C23.768 0.75 24.2499 1.23189 24.2499 1.82285V12.7604C24.2499 13.3516 23.768 13.8334 23.177 13.8334H15.3645C14.7734 13.8334 14.2915 13.3515 14.2915 12.7604V1.82285C14.2915 1.23194 14.7733 0.75 15.3645 0.75H22.427Z"
										stroke="currentColor" stroke-width="1.5" />
								</svg>
							</span>
							<span class="hide-toggle">Dashboard</span>
						</router-link>
					</li>

					<li class="nav-item hand-cursor" @click="openSubSidebar('analytics')">
						<a class="nav-link">
							<span class="col-3 fa fa-area-chart fa-lg"></span>
							<span class="col-8 hide-toggle">Analytics</span>
							<span class="col-2 fa-solid fa-arrow-right fa-xl"></span>
						</a>
					</li>

					<!-- @click="setActiveMenu('maintenanceSettings', true), toggleSubSidebar()" -->
					<li class="nav-item hand-cursor" @click="openSubSidebar('extensionConfiguration')">
						<a class="nav-link">
							<span class="col-3 fa fa-gears fa-lg"></span>
							<span class="col-8 hide-toggle">Configuration</span>
							<span class="col-2 fa-solid fa-arrow-right fa-xl"></span>
						</a>
					</li>

					<!-- <li class="nav-item" @click="setActiveMenu('browserSettings', true), toggleSubSidebar()">
						<a class="nav-link">
							<span class="col-3 fa fa-globe fa-lg"></span>
							<span class="col-8 hide-toggle">Browser Settings</span>
							<span class="col-2 fa-solid fa-arrow-right fa-xl"></span>
						</a>
					</li> -->

					<li v-cloak v-if="this.$store.state.auth.isSuperAdmin" class="nav-item hand-cursor"
						@click="openSubSidebar('adminSettings')">
						<a class="nav-link">
							<span class="col-3 fa fa-lock fa-lg"></span>
							<span class="col-8 hide-toggle">Admin Settings</span>
							<span class="col-2 fa-solid fa-arrow-right fa-xl"></span>
						</a>
					</li>

					<li class="nav-item hand-cursor" @click="openSubSidebar('platformGuide')">
						<a class="nav-link">
							<span class="col-3 fa fa-map fa-lg"></span>
							<span class="col-8 hide-toggle">Platform Guide</span>
							<span class="col-2 fa-solid fa-arrow-right fa-xl"></span>
						</a>
					</li>

					<li v-cloak v-if="this.$store.state.auth.isSuperAdmin" class="nav-item" @click="hideSubSidebar()">
						<router-link to="/admin/debugger" class="nav-link">
							<span class="col-3 fa fa-bug fa-lg"></span>
							<span class="hide-toggle">Debugger Module</span>
						</router-link>
					</li>

					<!-- <li class="nav-item">
						<router-link to="/faqs" class="nav-link">
							<span class="col-3 fa fa-question fa-lg"></span>
							<span class="hide-toggle">FAQs</span>
						</router-link>
					</li> -->
				</ul>
			</div>

			<!-- <div class="account-menu text-center">
				<button type="button" class="btn btn-outline-info text-light rounded-pill btn-sm"
					style="font-size: 14px; width: 90%; height:45px; font-weight: 900; border-color: #75CBDD;"
					@click="logout()">
					Logout
				</button>
			</div> -->

			<!-- <div class="account-menu-wrapper text-center">

				<div v-if="organisationsList" class="mb-3 dropdown dropup mx-4 organisation-info" ref="organisationMenuRef">
					<hr style="color: #d9d9d9;">
					<div class="row align-items-center" data-bs-toggle="dropdown">
						<span class="col-10" :title="organisation.name" style="font-size: 14px; font-weight: 900;">{{
							truncateLongText(organisation.name, 20) }}</span>
						<span class="col fa-solid fa-arrow-right fa-xl"></span>
					</div>
					<hr style="color: #d9d9d9;">

					<ul class="dropdown-menu dropdown-menu-end mb-3 organisation-menu">
						<li>
							<div class="mx-2 mb-1">
								<input v-model.trim="search" type="text" class="search-input form-control form-control-sm"
									placeholder="&#xF002; Search...."
									style="font-size: 12px;width:200px;border-radius: 5px;" @keyup="onSearch()" />
							</div>
						</li>
						<li v-if="organisationsList.length == 0"><a class="dropdown-item" href="#"> No records to display.
							</a></li>
						<li v-for="org in organisationsList" :key="org.id" :title="org.name">
							<a class="dropdown-item" :class="{ 'active': org.id == organisation.id }" href="#"
								@click="onSelectOrg(org)">{{ truncateLongText(org.name, 25) }}</a>
						</li>
					</ul>
				</div>


				<div class="mb-3">
					<hr class="mx-4" style="color: #d9d9d9;">
					<span style="font-size: 14px; font-weight: 900;">
						{{ user.first_name + " " + user.last_name }}
					</span>
					<hr class="mx-4" style="color: #d9d9d9;">
				</div>

				<button type="button" class="btn btn-outline-info text-light btn-sm"
					style="font-size: 14px; width: 90%; height:45px; font-weight: 900; border-color: #75CBDD;"
					@click="logout()">
					Logout
				</button>

			</div> -->

			<!-- <div class="account-selection text-center">
				<hr class="mx-4" style="color: #d9d9d9;" />
				<p class="label text-light" v-if="!this.$store.state.auth.isSuperAdmin">{{
					this.$store.state.auth.organisation_name }}</p>
				<div class="dropdown dropup" v-cloak v-if="this.$store.state.auth.isSuperAdmin">
					<button class="btn btn-outline-info text-light dropdown-toggle rounded-pill"
						style="font-size: 14px; width: 90%; height: 45px; font-weight: 900; border-color: #75CBDD;"
						type="button" @click="toggleDropdown">
						{{ this.$store.state.auth.organisation_name }}
					</button>
					<div class="dropdown-menu custom-dropdown-item" :class="{ show: isDropdownOpen }">
						<a class="dropdown-item" v-for="organisation in this.$store.state.auth.organisations"
							:key="organisation" @click="selectOption(organisation)">
							{{ organisation.name }}
						</a>
					</div>
				</div>

				<br>

				<div class="mx-3">
					<span style="font-size: 14px; font-weight: 900;">
						{{ user.first_name + " " + user.last_name }}
					</span>
				</div>

				<hr class="mx-4" style="color: #d9d9d9;" />
			</div> -->

			<div class="sidebar-footer">

				<!-- ═══ EXPANDED view (hidden when collapsed) ═══ -->
				<div v-if="!toggleMainSidebar" class="expanded-account">

					<!-- Footer divider -->
					<div class="sidebar-footer-divider"></div>

					<!-- 1. Workspace / Org Selector Tile (Super Admin only - Flyout to the RIGHT) -->
					<div v-if="this.$store.state.auth.isSuperAdmin && this.$store.state.auth.organisations"
						class="sidebar-footer-org-selector"
						:class="{ 'flyout-open': orgFlyoutOpen, 'user-menu-open': userDropupOpen }"
						@click="toggleOrgFlyout"
						ref="orgSelectorRef">
						
						<div class="sidebar-footer-org-btn">
							<div class="sidebar-footer-org-icon-badge">
								<i class="fa-regular fa-building"></i>
							</div>
							<div class="sidebar-footer-org-text">
								<span class="sidebar-footer-org-label">Switch Organisation</span>
								<span class="sidebar-footer-org-val" :title="this.$store.state.auth.organisation_name">
									{{ truncateText(this.$store.state.auth.organisation_name, 17) }}
								</span>
							</div>
							<i class="fa-solid fa-chevron-right sidebar-footer-org-arrow" :class="{ 'arrow-rotated': orgFlyoutOpen }"></i>
						</div>

						<!-- Org Flyout Menu (Pops to the RIGHT) -->
						<transition name="footer-flyout">
							<div v-if="orgFlyoutOpen" class="sidebar-footer-org-flyout" ref="orgFlyoutRef" @click.stop>
								<div class="sidebar-footer-flyout-header">
									<span class="sidebar-footer-flyout-title">Switch Organisation</span>
								</div>

								<div class="sidebar-footer-org-search">
									<div class="sidebar-footer-search-wrapper">
										<i class="fa-solid fa-magnifying-glass search-icon"></i>
										<input ref="orgSearchInputRef" v-model.trim="search" type="text"
											class="sidebar-footer-search-input"
											placeholder="Search organisation..." @keyup="onSearch()" />
									</div>
								</div>

								<div class="sidebar-footer-org-list">
									<a v-if="this.$store.state.auth.organisations.length == 0" class="sidebar-footer-dropdown-item disabled" href="#">
										No records to display.
									</a>
									<a v-for="org in this.$store.state.auth.temp_orgs" :key="org.orguuid"
										class="sidebar-footer-dropdown-item org-item"
										:class="{ 'org-active': org.orguuid == this.$store.state.auth.organisation.orguuid }"
										href="#" @click.prevent="selectOrgFromFlyout(org)" :title="org.name">
										<span class="org-item-name">{{ truncateText(org.name, 28) }}</span>
										<i v-if="org.orguuid == this.$store.state.auth.organisation.orguuid" class="fa-solid fa-check org-check-icon"></i>
									</a>
								</div>
							</div>
						</transition>
					</div>

					<!-- 1b. Static / Org Admin Organisation Display Tile -->
					<div v-else-if="this.$store.state.auth.organisation_name"
						class="sidebar-footer-org-selector"
						:class="{ 'static-org-selector': !this.$store.state.auth.hasOrgSettingsAccess, 'clickable-org-selector': this.$store.state.auth.hasOrgSettingsAccess, 'user-menu-open': userDropupOpen }"
						@click="this.$store.state.auth.hasOrgSettingsAccess ? goToOrgProfile() : null"
						:title="this.$store.state.auth.hasOrgSettingsAccess ? 'Open Organisation Settings · ' + this.$store.state.auth.organisation_name : this.$store.state.auth.organisation_name">
						
						<div class="sidebar-footer-org-btn">
							<div class="sidebar-footer-org-icon-badge">
								<i class="fa-regular fa-building"></i>
							</div>
							<div class="sidebar-footer-org-text">
								<span class="sidebar-footer-org-label">Organisation</span>
								<span class="sidebar-footer-org-val" :title="this.$store.state.auth.organisation_name">
									{{ truncateText(this.$store.state.auth.organisation_name, this.$store.state.auth.hasOrgSettingsAccess ? 17 : 20) }}
								</span>
							</div>
							<i v-if="this.$store.state.auth.hasOrgSettingsAccess" class="fa-solid fa-arrow-up-right-from-square sidebar-footer-org-link-icon" title="Organisation Settings"></i>
						</div>
					</div>

					<!-- 2. User Profile Dropup (In-flow: pushes Switch Organisation upwards) -->
					<transition name="user-dropup-flow">
						<div v-if="userDropupOpen" class="sidebar-footer-user-dropup-flow" ref="userDropupRef" @click.stop>
							<a v-if="this.$store.state.auth.hasOrgSettingsAccess" class="sidebar-footer-dropdown-item" href="#" @click.prevent="goToOrgProfile()">
								<i class="fa-regular fa-building"></i>
								<span>Organisation Settings</span>
							</a>
							<a class="sidebar-footer-dropdown-item" href="#" @click.prevent="goToAuthProfile()">
								<i class="fa-regular fa-user"></i>
								<span>User Settings</span>
							</a>
							<a class="sidebar-footer-dropdown-item" href="#" @click.prevent="copyAccountKey()">
								<i class="fa-regular fa-key"></i>
								<span>{{ accountKeyCopied ? 'Copied!' : 'Account Key' }}</span>
							</a>

							<div class="sidebar-footer-dropdown-divider"></div>
							<a class="sidebar-footer-dropdown-item logout-item" href="#" @click.prevent="logout()">
								<i class="fa-solid fa-arrow-right-from-bracket"></i>
								<span>Log Out</span>
							</a>
						</div>
					</transition>

					<!-- 3. User Row — clickable to open user profile dropup -->
					<div class="sidebar-footer-user" :class="{ 'dropup-open': userDropupOpen }" @click="toggleUserDropup" ref="footerUserRef">
						<!-- Avatar with status dot -->
						<div class="sidebar-footer-avatar">
							<span class="sidebar-footer-avatar-initials">{{ userInitials }}</span>
							<span class="sidebar-footer-status-dot"></span>
						</div>

						<!-- User info -->
						<div class="sidebar-footer-info">
							<span class="sidebar-footer-name">{{ user.first_name + ' ' + user.last_name }}</span>
							<span class="sidebar-footer-meta">
								<span class="sidebar-footer-role" :class="'role-' + userRoleClass">{{ userRole }}</span>
							</span>
						</div>

						<!-- Action chevron + Logout shortcut -->
						<div class="sidebar-footer-actions">
							<button class="sidebar-footer-logout-btn" @click.stop="logout()" title="Log Out">
								<i class="fa-solid fa-arrow-right-from-bracket"></i>
							</button>
							<i class="fa-solid fa-chevron-up sidebar-footer-chevron" :class="{ 'arrow-rotated': userDropupOpen }"></i>
						</div>
					</div>
				</div>

				<!-- ═══ COLLAPSED view (shown only when sidebar is collapsed) ═══ -->
				<div v-if="toggleMainSidebar" class="collapsed-account">
					<div class="sidebar-footer-divider collapsed-divider"></div>

					<!-- Org icon (SuperAdmin gets switcher flyout, standard user gets static icon with tooltip) -->
					<div v-if="this.$store.state.auth.isSuperAdmin && this.$store.state.auth.organisations"
						class="collapsed-icon-wrapper" ref="collapsedOrgBtnRef">
						<div class="collapsed-icon-btn collapsed-user-tooltip"
							:class="{ 'active-btn': collapsedOrgFlyoutOpen }"
							:data-tooltip="this.$store.state.auth.organisation_name"
							@click="toggleCollapsedOrgFlyout">
							<div v-if="this.$store.state.auth.logo != '' && this.$store.state.auth.logo.length > 1"
								class="collapsed-org-logo rounded-circle">
								<img :src="this.$store.state.auth.logo" :alt="this.$store.state.auth.organisation_name"
									class="w-100 h-100" style="border-radius: 50%;" />
							</div>
							<div v-else class="collapsed-org-logo collapsed-org-letter rounded-circle">
								{{ this.$store.state.auth.organisation_name ? this.$store.state.auth.organisation_name.charAt(0).toUpperCase() : '?' }}
							</div>
						</div>

						<!-- Collapsed Org Flyout to the Right -->
						<transition name="footer-flyout">
							<div v-if="collapsedOrgFlyoutOpen" class="sidebar-footer-org-flyout collapsed-flyout-pos" ref="collapsedOrgFlyoutRef" @click.stop>
								<div class="sidebar-footer-flyout-header">
									<span class="sidebar-footer-flyout-title">Switch Organisation</span>
								</div>

								<div class="sidebar-footer-org-search">
									<div class="sidebar-footer-search-wrapper">
										<i class="fa-solid fa-magnifying-glass search-icon"></i>
										<input ref="collapsedOrgSearchInputRef" v-model.trim="search" type="text"
											class="sidebar-footer-search-input"
											placeholder="Search organisation..." @keyup="onSearch()" />
									</div>
								</div>

								<div class="sidebar-footer-org-list">
									<a v-if="this.$store.state.auth.organisations.length == 0" class="sidebar-footer-dropdown-item disabled" href="#">
										No records to display.
									</a>
									<a v-for="org in this.$store.state.auth.temp_orgs" :key="org.orguuid"
										class="sidebar-footer-dropdown-item org-item"
										:class="{ 'org-active': org.orguuid == this.$store.state.auth.organisation.orguuid }"
										href="#" @click.prevent="selectOrgFromCollapsedFlyout(org)" :title="org.name">
										<span class="org-item-name">{{ truncateText(org.name, 28) }}</span>
										<i v-if="org.orguuid == this.$store.state.auth.organisation.orguuid" class="fa-solid fa-check org-check-icon"></i>
									</a>
								</div>
							</div>
						</transition>
					</div>

					<div v-else class="collapsed-icon-wrapper">
						<div class="collapsed-icon-btn collapsed-user-tooltip"
							:class="{ 'clickable-btn': this.$store.state.auth.hasOrgSettingsAccess }"
							:data-tooltip="(this.$store.state.auth.hasOrgSettingsAccess ? 'Organisation Settings · ' : '') + this.$store.state.auth.organisation_name"
							@click="this.$store.state.auth.hasOrgSettingsAccess ? goToOrgProfile() : null">
							<div v-if="this.$store.state.auth.logo != '' && this.$store.state.auth.logo.length > 1"
								class="collapsed-org-logo rounded-circle">
								<img :src="this.$store.state.auth.logo" :alt="this.$store.state.auth.organisation_name"
									class="w-100 h-100" style="border-radius: 50%;" />
							</div>
							<div v-else class="collapsed-org-logo collapsed-org-letter rounded-circle">
								{{ this.$store.state.auth.organisation_name ? this.$store.state.auth.organisation_name.charAt(0).toUpperCase() : '?' }}
							</div>
						</div>
					</div>

					<!-- User avatar with tooltip + status dot (Opens user flyout to right) -->
					<div class="collapsed-icon-wrapper" ref="collapsedUserBtnRef">
						<div class="collapsed-icon-btn collapsed-user-tooltip"
							:class="{ 'active-btn': collapsedUserFlyoutOpen }"
							:data-tooltip="user.first_name + ' ' + user.last_name + ' · ' + $store.state.auth.organisation_name"
							@click="toggleCollapsedUserFlyout">
							<div class="collapsed-user-avatar rounded-circle">
								{{ userInitials }}
								<span class="sidebar-footer-status-dot collapsed-status-dot"></span>
							</div>
						</div>

						<!-- Collapsed User Flyout to the Right -->
						<transition name="footer-flyout">
							<div v-if="collapsedUserFlyoutOpen" class="sidebar-footer-org-flyout collapsed-flyout-pos collapsed-user-menu" ref="collapsedUserFlyoutRef" @click.stop>
								<div class="sidebar-footer-flyout-header user-flyout-header">
									<div class="collapsed-user-header-info">
										<span class="collapsed-user-header-name">{{ user.first_name + ' ' + user.last_name }}</span>
										<span class="sidebar-footer-role mt-1" :class="'role-' + userRoleClass">{{ userRole }}</span>
									</div>
								</div>

								<div class="sidebar-footer-org-list">
									<a v-if="this.$store.state.auth.hasOrgSettingsAccess" class="sidebar-footer-dropdown-item" href="#" @click.prevent="goToOrgProfile()">
										<i class="fa-regular fa-building"></i>
										<span>Organisation Settings</span>
									</a>
									<a class="sidebar-footer-dropdown-item" href="#" @click.prevent="goToAuthProfile()">
										<i class="fa-regular fa-user"></i>
										<span>User Settings</span>
									</a>
									<a class="sidebar-footer-dropdown-item" href="#" @click.prevent="copyAccountKey()">
										<i class="fa-regular fa-key"></i>
										<span>{{ accountKeyCopied ? 'Copied!' : 'Account Key' }}</span>
									</a>

									<div class="sidebar-footer-dropdown-divider"></div>
									<a class="sidebar-footer-dropdown-item logout-item" href="#" @click.prevent="logout()">
										<i class="fa-solid fa-arrow-right-from-bracket"></i>
										<span>Log Out</span>
									</a>
								</div>
							</div>
						</transition>
					</div>

					<!-- Logout shortcut -->
					<div class="collapsed-logout-btn" @click="logout()" title="Log Out">
						<i class="fa-solid fa-arrow-right-from-bracket"></i>
					</div>
				</div>

			</div>
		</div>

		<div class="subSidebar-container" :class="{ 'show': showSubSidebar, 'sidebar-collapsed': toggleMainSidebar }">

			<div class="hideSubSidebar hide-mobile" @click="toggleSubSidebar()">
				<i class="fas fa-chevron-left"></i>
			</div>

			<div class="row justify-content-center pt-5">
				<div class="rounded-circle d-flex align-items-center" style="width:50px;height:50px;background:#e9e9e9;"
					alt="Avatar">
					<img src="@/assets/img/vertex_sublogo.png" class="img-fluid" />
				</div>
				<div>
					<p class="mt-2 text-center" style="color:gray; font-size:14px;">Vertex Cyber Security</p>
					<hr class="mx-4" />
				</div>
			</div>


			<div class="navigation">
				<!-- Extension Configuration -->
				<ul class="nav flex-column subSidebar-nav" v-if="activeMenu == 'extensionConfiguration'">
					<li class="nav-item">
						<router-link to="/account-settings" class="nav-link">Settings</router-link>
					</li>
					<li class="nav-item">
						<router-link to="/account-categories" class="nav-link">Categories</router-link>
					</li>
					<li class="nav-item">
						<router-link to="/account-government-tlds" class="nav-link">Government TLDs</router-link>
					</li>
					<li class="nav-item">
						<router-link to="/account-ai-categories" class="nav-link">AI Categories</router-link>
					</li>
					<!-- <li class="nav-item">
						<router-link to="/account-doh-blocking" class="nav-link">DoH Blocking</router-link>
					</li> -->
					<li class="nav-item">
						<router-link to="/account-allow-list" class="nav-link">Allow List</router-link>
					</li>
					<li class="nav-item">
						<router-link to="/account-block-list" class="nav-link">Block List</router-link>
					</li>
					<!-- <li class="nav-item">
						<router-link to="/account-domain-list" class="nav-link">
							Domain List <span class="badge bg-warning text-dark ms-1" style="font-size: 10px; font-weight: bold; border-radius: 4px;">Beta</span>
						</router-link>
					</li> -->
					<li class="nav-item">
						<router-link to="/account-api-keys" class="nav-link">Account API Keys</router-link>
					</li>
					<li class="nav-item-header">
						Browser Allocation
					</li>
					<li class="nav-item">
						<router-link to="/account-extension-keys" class="nav-link">Extension Keys</router-link>
					</li>
					<li class="nav-item">
						<router-link to="/account-domains" class="nav-link">Account Domains</router-link>
					</li>
					<li class="nav-item">
						<router-link to="/account-ips" class="nav-link">Account IPs</router-link>
					</li>
				</ul>
			</div>

			<div class="navigation">
				<!-- Analytics -->
				<ul class="nav flex-column subSidebar-nav" v-if="activeMenu == 'analytics'">
					<li class="nav-item">
						<router-link to="/log-history" class="nav-link">Log History</router-link>
					</li>
					<li class="nav-item">
						<router-link to="/active-keys" class="nav-link">Active Keys Report</router-link>
					</li>
					<li class="nav-item">
						<router-link to="/compliance-report" class="nav-link">Compliance Report</router-link>
					</li>
					<li class="nav-item">
						<router-link to="/reported-websites" class="nav-link">Reported Websites</router-link>
					</li>
					<li class="nav-item">
						<router-link to="/audit-logs" class="nav-link">Audit Log</router-link>
					</li>
				</ul>
			</div>

			<div class="navigation">
				<!-- Admin Settings -->
				<ul class="nav flex-column subSidebar-nav" v-if="activeMenu == 'adminSettings'">
					<li class="nav-item">
						<router-link to="/admin/admin-reports" class="nav-link">Admin Reports</router-link>
					</li>
					<li class="nav-item">
						<router-link to="/admin/common-cloud-storage" class="nav-link">Common Cloud
							Storage</router-link>
					</li>
					<li class="nav-item">
						<router-link to="/admin/blocked-domains" class="nav-link">Blocked Websites</router-link>
					</li>
					<li class="nav-item">
						<router-link to="/admin/cached-domains" class="nav-link">Cached Domains</router-link>
					</li>
					<li class="nav-item">
						<router-link to="/admin/reported-websites" class="nav-link">Reported Websites</router-link>
					</li>
					<li class="nav-item">
						<router-link to="/admin/password-websites" class="nav-link">Password Websites</router-link>
					</li>
					<li class="nav-item">
						<router-link to="/admin/unsafe-websites" class="nav-link">Unsafe Websites</router-link>
					</li>
					<li class="nav-item">
						<router-link to="/admin/allocate-extension-keys" class="nav-link">Extension Key Allocation</router-link>
					</li>
					<li class="nav-item">
						<router-link to="/admin/cron-jobs" class="nav-link">Cron Jobs</router-link>
					</li>
					<li class="nav-item">
						<router-link to="/admin/ai-categories" class="nav-link">AI Categories</router-link>
					</li>
					<li class="nav-item">
						<router-link to="/admin/government-tlds" class="nav-link">Government TLDs</router-link>
					</li>
					<!-- <li class="nav-item">
						<router-link to="/admin/insights" class="nav-link">Insights</router-link>
					</li> -->
				</ul>
			</div>

			<div class="navigation">
				<!-- Platform Guide -->
				<ul class="nav flex-column subSidebar-nav" v-if="activeMenu == 'platformGuide'">
					<li class="nav-item">
						<router-link to="/platform-guide/installation" class="nav-link">Installation Guide</router-link>
					</li>
					<li class="nav-item">
						<router-link to="/platform-guide/user-guide" class="nav-link">User Guide</router-link>
					</li>
					<!-- <li class="nav-item">
						<router-link to="/platform-guide/changelogs" class="nav-link">Changelogs</router-link>
					</li> -->
				</ul>
			</div>
		</div>
	</div>
</template>

<script>

export default ({

	data() {
		return {
			toggleMainSidebar: false,
			showSubSidebar: false,
			activeMenu: '',
			navClicked: false,
			organisations: this.$store.state.auth.organisations,
			user: {
				id: '',
				first_name: '',
				last_name: '',
			},
			options: [],
			search: '',
			selectedOption: null,
			selectedOptionName: null,
			isDropdownOpen: false,
			orgFlyoutOpen: false,
			userDropupOpen: false,
			collapsedOrgFlyoutOpen: false,
			collapsedUserFlyoutOpen: false,
			accountKeyCopied: false,
		};
	},

	computed: {
		userInitials() {
			const f = this.user.first_name ? this.user.first_name.charAt(0).toUpperCase() : ''
			const l = this.user.last_name ? this.user.last_name.charAt(0).toUpperCase() : ''
			return f + l
		},
		userRole() {
			if (this.$store.state.auth.isVertexAnalyst) return 'XSurfLog Analyst'
			if (this.$store.state.auth.isSuperAdmin) return 'Super Admin'
			if (this.$store.state.auth.isOrgAdmin) return 'Org Admin'
			return 'User'
		},
		userRoleClass() {
			if (this.$store.state.auth.isVertexAnalyst) return 'xsurflog-analyst'
			if (this.$store.state.auth.isSuperAdmin) return 'super-admin'
			if (this.$store.state.auth.isOrgAdmin) return 'org-admin'
			return 'user'
		},
	},

	watch: {
		toggleMainSidebar() {
			// When sidebar toggle state changes, close sub-sidebar and all popups
			this.showSubSidebar = false
			this.pushContent(false)
			this.orgFlyoutOpen = false
			this.userDropupOpen = false
			this.collapsedOrgFlyoutOpen = false
			this.collapsedUserFlyoutOpen = false
		},
	},

	mounted() {
		this.init();

		// Close footer dropdowns on outside click
		document.addEventListener('click', this.closeFooterPopups)
	},

	beforeUnmount() {
		document.removeEventListener('click', this.closeFooterPopups)
	},

	methods: {

		toggleOrgFlyout() {
			this.orgFlyoutOpen = !this.orgFlyoutOpen
			if (this.orgFlyoutOpen) {
				this.userDropupOpen = false
				this.$nextTick(() => {
					if (this.$refs.orgSearchInputRef) {
						this.$refs.orgSearchInputRef.focus()
					}
				})
			} else {
				this.resetOrganisationsList()
			}
		},

		selectOrgFromFlyout(option) {
			this.orgFlyoutOpen = false
			this.selectOption(option)
		},

		toggleUserDropup() {
			this.userDropupOpen = !this.userDropupOpen
			if (this.userDropupOpen) {
				this.orgFlyoutOpen = false
				this.resetOrganisationsList()
			}
		},

		toggleCollapsedOrgFlyout() {
			this.collapsedOrgFlyoutOpen = !this.collapsedOrgFlyoutOpen
			if (this.collapsedOrgFlyoutOpen) {
				this.collapsedUserFlyoutOpen = false
				this.$nextTick(() => {
					if (this.$refs.collapsedOrgSearchInputRef) {
						this.$refs.collapsedOrgSearchInputRef.focus()
					}
				})
			} else {
				this.resetOrganisationsList()
			}
		},

		selectOrgFromCollapsedFlyout(option) {
			this.collapsedOrgFlyoutOpen = false
			this.selectOption(option)
		},

		toggleCollapsedUserFlyout() {
			this.collapsedUserFlyoutOpen = !this.collapsedUserFlyoutOpen
			if (this.collapsedUserFlyoutOpen) {
				this.collapsedOrgFlyoutOpen = false
				this.resetOrganisationsList()
			}
		},

		closeFooterPopups(e) {
			if (this.userDropupOpen) {
				const userWrapper = this.$refs.footerUserRef
				const dropupRef = this.$refs.userDropupRef
				if (userWrapper && !userWrapper.contains(e.target) && (!dropupRef || !dropupRef.contains(e.target))) {
					this.userDropupOpen = false
				}
			}
			if (this.orgFlyoutOpen) {
				const orgSelector = this.$refs.orgSelectorRef
				const orgFlyout = this.$refs.orgFlyoutRef
				if (orgSelector && !orgSelector.contains(e.target) && (!orgFlyout || !orgFlyout.contains(e.target))) {
					this.orgFlyoutOpen = false
					this.resetOrganisationsList()
				}
			}
			if (this.collapsedUserFlyoutOpen) {
				const userBtn = this.$refs.collapsedUserBtnRef
				const userFlyout = this.$refs.collapsedUserFlyoutRef
				if (userBtn && !userBtn.contains(e.target) && (!userFlyout || !userFlyout.contains(e.target))) {
					this.collapsedUserFlyoutOpen = false
				}
			}
			if (this.collapsedOrgFlyoutOpen) {
				const orgBtn = this.$refs.collapsedOrgBtnRef
				const orgFlyout = this.$refs.collapsedOrgFlyoutRef
				if (orgBtn && !orgBtn.contains(e.target) && (!orgFlyout || !orgFlyout.contains(e.target))) {
					this.collapsedOrgFlyoutOpen = false
					this.resetOrganisationsList()
				}
			}
		},

		init() {

			if (this.$store.state.auth.fromSwitchBool) {
				this.$toast.success(`Switching to ${this.$store.state.auth.organisation.name}`)
				this.$store.commit("auth/fromSwitch", false)
			}

			if (this.$store.state.auth.isSuperAdmin) {
				//if(this.$store.state.auth.organisation == null){
				this.getXSurflogOrganisations()
				//}
			}

			this.user.id = this.$store.state.auth.jwtPayload.user_id
			this.user.first_name = this.$store.state.auth.jwtPayload.first_name
			this.user.last_name = this.$store.state.auth.jwtPayload.last_name

			//console.log("Payload:", this.$store.state.auth.jwtPayload)
		},

		async copyAccountKey() {
			try {
				let resp = null
				resp = await this.$axios.get("dashboard/" + this.$store.state.auth.organisation_uuid + "/get-account-account-key")
				if (resp.data.success != null && resp.data.success == false) {
					return
				} else {
					navigator.clipboard.writeText(resp.data.account_key).then(() => {
						this.accountKeyCopied = true
						setTimeout(() => { this.accountKeyCopied = false }, 2000)
					}).catch((err) => {
						this.$toast.error("Unable to copy to clipboard: " + err)
						return
					});
				}

			} catch (error) {
				console.log(error)
				return
			}

			this.$toast.success("Succesfully copied Account Key to clipboard")
		},

		resetOrganisationsList() {
			this.search = ""
			this.$store.commit("auth/searchOrg", "")
		},

		goToAuthProfile() {
			window.open(this.$config.getAuthBaseUrl() + '/user-settings/', '_blank');
		},

		goToOrgProfile() {

			let org_id = 0
			if (this.$store.state.auth.isSuperAdmin) {
				org_id = this.$store.state.auth.organisation.id
			} else {
				org_id = this.$store.state.auth.org_id
			}


			window.open(this.$config.getAuthBaseUrl() + '/organisations/' + org_id + '/settings', '_blank');
		},

		truncateText(text, limit) {

			if (text === null)
				return
			if (text === '')
				return

			if (text.length <= limit) {
				return text; // Return the original text if it's within the limit
			} else {
				return text.slice(0, limit) + '...'; // Truncate the text and add ellipsis
			}
		},

		toggleSidebar() {
			this.toggleMainSidebar = !this.toggleMainSidebar
		},

		toggleSubSidebar() {
			this.showSubSidebar = !this.showSubSidebar
			this.pushContent(this.showSubSidebar)
		},

		hideSubSidebar() { //called when content is clicked
			this.showSubSidebar = false
			this.pushContent(false)
		},

		pushContent(open) {
			console.log('[pushContent] called with:', open)
			this.$nextTick(() => {
				const el = document.querySelector('.content')
				console.log('[pushContent] content element:', el)
				if (el) {
					el.style.paddingLeft = open ? '285px' : '30px'
				}
			})
		},

		openSubSidebar(menuName) {
			if (this.activeMenu === menuName && this.showSubSidebar) {
				// Same menu clicked while open → close it
				this.showSubSidebar = false
				this.pushContent(false)
			} else {
				// Different menu or sub-sidebar is closed → open/switch
				this.activeMenu = menuName
				this.showSidebar = true
				this.navClicked = !this.navClicked
				this.showSubSidebar = true
				this.pushContent(true)
			}
		},

		setActiveMenu(activeMenu, showSubSidebar) {
			this.showSidebar = showSubSidebar
			this.activeMenu = activeMenu
			this.navClicked = !this.navClicked
		},

		logout() {
			this.$store.commit("auth/authenticated", false)
			this.$store.dispatch('auth/logout');
		},

		onSearch() {
			this.$store.commit("auth/searchOrg", this.search)
		},

		toggleDropdown() {
			this.isDropdownOpen = !this.isDropdownOpen;
		},
		selectOption(option) {

			
			this.CheckAccount(option.orguuid, option.name)
			
			this.isDropdownOpen = false;
			this.$store.commit("auth/setOrganisation", option)
			this.$store.commit("auth/fromSwitch", true)
			//this.$router.push(this.$route.fullPath);

			setTimeout(()=>{
				this.$router.go(this.$router.currentRoute)
			}, 650);


			
			//this.$toast.success(`Switching to ${option.name}`)
			//this.selectedOption = this.$store.state.auth.organisation;
			//this.selectedOptionName = this.$store.state.auth.organisation.name;
		},

		async getXSurflogOrganisations() {
			await this.$axios.get("/admin-common/get-xsurflog-organisations")
				.then((response) => {

					//console.log("nag sulod d sa get organisations")
					//console.log(response)
					if (response.data.organisations.length > 0) {
						//console.log(response.data.organisations)
						this.$store.commit("auth/setOrganisations", response.data.organisations)
						//console.log(`Organisation: ${this.$store.state.auth.organisation}`)
						//console.log(this.$store.state.auth.organisation)
						//console.log(response.data.organisations[0])
						if (this.$store.state.auth.organisation == null || this.$store.state.auth.organisation == undefined) {
							//console.log("Hello nag sulod d")

							if (response.data.organisations.length > 0) {
								let activeOrg = null;
								const targetUuid = this.$store.state.auth.jwtPayload?.organisation_uuid;
								if (targetUuid) {
									activeOrg = response.data.organisations.find(org => org.orguuid === targetUuid);
								}
								if (!activeOrg) {
									activeOrg = response.data.organisations[0];
								}
								this.$store.commit("auth/setOrganisation", activeOrg)
								this.CheckAccount(activeOrg.orguuid, activeOrg.name)
							}

						}
						//console.log(this.$store.state.auth.organisation)
					}
				})
				.catch((error) => {
					console.log(error)
					//this.$toast.error("An error has occured.")
				})
		},

		async CheckAccount(OrgUuid, Name) {
			try {
				const payLoad = {
					org_uuid: OrgUuid,
					name: Name
				}

				await fetch(process.env.VUE_APP_API_BASE_URL + "/api/main/v1/auth/non-login/check-account-exist", {
					method: "POST",
					body: JSON.stringify(payLoad),
					headers: {
						"Content-type": "application/json; charset=UTF-8"
					}
				})
				// console.log(OrgUuid)
				// console.log(Name)

				// const resp = await app.$axios.post("non-login/check-account-exist", payLoad)
				// if(resp.data.success != null && resp.data.success == false ) {
				// 	this.$toast.error(resp.data.message)
				// } else {
				// 	this.$toast.success(resp.data.message)
				// 	this.getAllowList()
				// }
			} catch (error) {
				console.log(error)
				//app.$toast.error(error.response.data.message)
			}
		}
	},

})
</script>

<style>
/* ═══════════════════════════════════════════════
   SIDEBAR — Matching Spark Design
   ═══════════════════════════════════════════════ */

/* ── Toggle Button (from Spark) ── */
.toggle-bar {
	position: absolute;
	right: -18px;
	top: 50%;
	transform: translateY(-50%);
	z-index: 1001;
}

.toggle-menu-btn {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 36px;
	height: 36px;
	background: linear-gradient(135deg, #00a0c1, #0088a3);
	border: none;
	border-radius: 50%;
	color: white;
	cursor: pointer;
	box-shadow: 0 4px 12px rgba(0, 160, 193, 0.3);
	transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
	font-size: 14px;
}

.toggle-menu-btn:hover {
	transform: scale(1.1);
	box-shadow: 0 6px 16px rgba(0, 160, 193, 0.4);
}

.toggle-menu-btn:active {
	transform: scale(0.95);
}

/* ── Hand Cursor ── */
.hand-cursor {
	cursor: pointer;
}


/* ═══════════════════════════════════════════════
   SIDEBAR FOOTER — Spark Style
   ═══════════════════════════════════════════════ */

.sidebar-footer {
	bottom: 0;
	position: absolute;
	color: #fff;
	width: 100%;
	padding-bottom: 12px;
}

/* ── Footer Divider ── */
.sidebar-footer-divider {
	height: 1px;
	background: linear-gradient(90deg, transparent, rgba(255,255,255,0.15), transparent);
	margin: 0 20px 12px;
}

.collapsed-divider {
	margin: 0 8px 8px;
}

/* ── User Row ── */
.sidebar-footer-user {
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 8px 16px;
	margin: 0 8px;
	border-radius: 10px;
	cursor: pointer;
	transition: background-color 0.2s ease;
	position: relative;
}

.sidebar-footer-user:hover {
	background-color: rgba(122, 155, 184, 0.3);
}

/* ── Avatar ── */
.sidebar-footer-avatar {
	width: 38px;
	height: 38px;
	min-width: 38px;
	border-radius: 50%;
	background: linear-gradient(135deg, #00a0c1, #0088a3);
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	border: 2px solid rgba(255,255,255,0.2);
	transition: border-color 0.2s ease;
}

.sidebar-footer-user:hover .sidebar-footer-avatar {
	border-color: rgba(255,255,255,0.5);
}

.sidebar-footer-avatar-initials {
	font-size: 13px;
	font-weight: 700;
	color: #fff;
	letter-spacing: 0.5px;
}

/* ── Online Status Dot ── */
.sidebar-footer-status-dot {
	position: absolute;
	bottom: 1px;
	right: 1px;
	width: 10px;
	height: 10px;
	background: #34d399;
	border-radius: 50%;
	border: 2px solid #435666;
	box-shadow: 0 0 0 1px rgba(52, 211, 153, 0.3);
}

.collapsed-status-dot {
	bottom: 0;
	right: -1px;
	width: 9px;
	height: 9px;
}

/* ── User Info ── */
.sidebar-footer-info {
	display: flex;
	flex-direction: column;
	gap: 2px;
	overflow: hidden;
	flex: 1;
	min-width: 0;
}

.sidebar-footer-name {
	font-size: 13px;
	font-weight: 700;
	color: #fff;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	line-height: 1.3;
}

.sidebar-footer-meta {
	display: flex;
	align-items: center;
	gap: 4px;
	font-size: 11px;
	line-height: 1.3;
}

.sidebar-footer-org {
	color: #a3c0d1;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.sidebar-footer-separator {
	color: rgba(255,255,255,0.3);
	flex-shrink: 0;
}

.sidebar-footer-role {
	font-size: 10px;
	font-weight: 600;
	padding: 1px 6px;
	border-radius: 4px;
	white-space: nowrap;
	flex-shrink: 0;
	letter-spacing: 0.3px;
}

.sidebar-footer-role.role-super-admin {
	background: rgba(0, 160, 193, 0.25);
	color: #75CBDD;
}

.sidebar-footer-role.role-xsurflog-analyst {
	background: rgba(230, 81, 0, 0.2);
	color: #ff9800;
}

.sidebar-footer-role.role-org-admin {
	background: rgba(99, 147, 193, 0.25);
	color: #9ec5e0;
}

.sidebar-footer-role.role-user {
	background: rgba(163, 192, 209, 0.2);
	color: #a3c0d1;
}

/* ── Actions Group (chevrons + logout) ── */
.sidebar-footer-actions {
	display: flex;
	align-items: center;
	gap: 2px;
	flex-shrink: 0;
	margin-left: auto;
}

.sidebar-footer-chevron {
	font-size: 10px;
	color: #a3c0d1;
	transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), color 0.2s;
}

.sidebar-footer-user:hover .sidebar-footer-chevron {
	color: #fff;
}


/* ── Logout Shortcut (always visible) ── */
.sidebar-footer-logout-btn {
	background: none;
	border: none;
	color: #6c8ca0;
	font-size: 12px;
	padding: 4px 6px;
	cursor: pointer;
	transition: color 0.15s, background-color 0.15s;
	border-radius: 4px;
	margin-right: 4px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.sidebar-footer-logout-btn:hover {
	color: #ff6b6b;
	background-color: rgba(255, 107, 107, 0.12);
}

/* ── Workspace / Org Selector Tile ── */
.sidebar-footer-org-selector {
	position: relative;
	margin: 0 10px 8px 10px;
	border-radius: 8px;
	cursor: pointer;
	user-select: none;
}

.sidebar-footer-org-btn {
	display: flex;
	align-items: center;
	gap: 9px;
	padding: 7px 10px;
	border-radius: 8px;
	background: rgba(255, 255, 255, 0.04);
	border: 1px solid rgba(255, 255, 255, 0.08);
	transition: background 0.15s ease, border-color 0.15s ease;
}

.sidebar-footer-org-selector:hover .sidebar-footer-org-btn,
.sidebar-footer-org-selector.flyout-open .sidebar-footer-org-btn {
	background: rgba(117, 203, 221, 0.1);
	border-color: rgba(117, 203, 221, 0.35);
}

.sidebar-footer-org-icon-badge {
	width: 26px;
	height: 26px;
	border-radius: 6px;
	background: rgba(117, 203, 221, 0.15);
	color: #75CBDD;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 12px;
	flex-shrink: 0;
	transition: background 0.15s, color 0.15s;
}

.sidebar-footer-org-selector:hover .sidebar-footer-org-icon-badge {
	background: #75CBDD;
	color: #1a2936;
}

.sidebar-footer-org-text {
	display: flex;
	flex-direction: column;
	min-width: 0;
	flex: 1;
	line-height: 1.25;
}

.sidebar-footer-org-label {
	font-size: 9px;
	font-weight: 700;
	color: #7a9bb8;
	letter-spacing: 0.7px;
	text-transform: uppercase;
}

.sidebar-footer-org-val {
	font-size: 12px;
	font-weight: 600;
	color: #ffffff;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	margin-top: 1px;
}

.sidebar-footer-org-arrow {
	font-size: 10px;
	color: #6c8ca0;
	transition: transform 0.2s cubic-bezier(0.16, 1, 0.3, 1), color 0.15s;
	margin-left: auto;
	flex-shrink: 0;
}

.sidebar-footer-org-selector:hover .sidebar-footer-org-arrow {
	color: #75CBDD;
}

.sidebar-footer-org-arrow.arrow-rotated {
	transform: rotate(180deg);
	color: #75CBDD;
}

.sidebar-footer-org-link-icon {
	font-size: 10px;
	color: #6c8ca0;
	transition: color 0.15s ease, transform 0.15s ease;
	margin-left: auto;
	flex-shrink: 0;
}

.sidebar-footer-org-selector:hover .sidebar-footer-org-link-icon {
	color: #75CBDD;
}

.sidebar-footer-org-selector.static-org-selector {
	cursor: default;
}

.sidebar-footer-org-selector.static-org-selector:hover .sidebar-footer-org-btn {
	background: rgba(255, 255, 255, 0.04);
	border-color: rgba(255, 255, 255, 0.08);
}

.sidebar-footer-org-selector.static-org-selector:hover .sidebar-footer-org-icon-badge {
	background: rgba(117, 203, 221, 0.15);
	color: #75CBDD;
}

/* ── Org Flyout Menu (Pops to the RIGHT of the Org Tile) ── */
.sidebar-footer-org-flyout {
	position: absolute;
	bottom: 0px;
	left: calc(100% + 12px);
	width: 280px;
	background: #364756;
	border: 1px solid rgba(255, 255, 255, 0.14);
	border-radius: 12px;
	box-shadow: 0 12px 32px rgba(0,0,0,0.45), 0 2px 8px rgba(0,0,0,0.2);
	padding: 8px 0;
	z-index: 1070;
	overflow: hidden;
	transform-origin: bottom left;
}

.sidebar-footer-flyout-header {
	padding: 2px 14px 8px;
	border-bottom: 1px solid rgba(255, 255, 255, 0.08);
	margin-bottom: 6px;
}

.sidebar-footer-flyout-title {
	font-size: 11px;
	font-weight: 700;
	color: #a3c0d1;
	text-transform: uppercase;
	letter-spacing: 0.8px;
}

/* ── Org Search inside Flyout ── */
.sidebar-footer-org-search {
	padding: 4px 12px 6px;
}

.sidebar-footer-search-wrapper {
	position: relative;
	display: flex;
	align-items: center;
}

.sidebar-footer-search-wrapper .search-icon {
	position: absolute;
	left: 10px;
	font-size: 11px;
	color: #6c8ca0;
	pointer-events: none;
}

.sidebar-footer-search-input {
	width: 100%;
	padding: 6px 10px 6px 28px;
	font-size: 12px;
	border: 1px solid rgba(255,255,255,0.12);
	border-radius: 6px;
	background: rgba(0,0,0,0.18);
	color: #fff;
	outline: none;
	transition: border-color 0.2s, background 0.2s;
	font-family: 'Roboto', sans-serif;
}

.sidebar-footer-search-input::placeholder {
	color: #6c8ca0;
}

.sidebar-footer-search-input:focus {
	border-color: rgba(0, 160, 193, 0.6);
	background: rgba(0,0,0,0.25);
}

/* ── Org List inside Flyout ── */
.sidebar-footer-org-list {
	max-height: 260px;
	overflow-y: auto;
	overflow-x: hidden;
	padding: 0 4px;
}

.sidebar-footer-dropdown-item {
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 8px 14px;
	color: #c8d8e4;
	font-size: 13px;
	font-weight: 500;
	text-decoration: none;
	transition: background-color 0.15s, color 0.15s;
	cursor: pointer;
}

.sidebar-footer-dropdown-item:hover {
	background-color: rgba(122, 155, 184, 0.2);
	color: #fff;
}

.sidebar-footer-dropdown-item i {
	font-size: 13px;
	width: 16px;
	text-align: center;
	opacity: 0.7;
	flex-shrink: 0;
}

.sidebar-footer-dropdown-item.org-item {
	padding: 7px 10px;
	border-radius: 6px;
	font-size: 12.5px;
	margin: 1px 0;
}

.sidebar-footer-dropdown-item.org-active {
	background-color: rgba(0, 160, 193, 0.2);
	color: #75CBDD;
	font-weight: 600;
}

.sidebar-footer-dropdown-item .org-item-name {
	flex: 1;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.sidebar-footer-dropdown-item .org-check-icon {
	margin-left: auto;
	font-size: 11px;
	color: #75CBDD;
}

.sidebar-footer-dropdown-item.disabled {
	color: #6c7c8a;
	pointer-events: none;
}

.sidebar-footer-dropdown-item.logout-item {
	color: #ff8a8a;
}

.sidebar-footer-dropdown-item.logout-item:hover {
	color: #ff6b6b;
	background-color: rgba(255, 107, 107, 0.1);
}

.sidebar-footer-dropdown-divider {
	height: 1px;
	background: rgba(255,255,255,0.08);
	margin: 6px 12px;
}

/* ── User Profile Menu Flow (In-Flow Accordion Dropup that pushes Org tile up) ── */
.sidebar-footer-user-dropup-flow {
	margin: 0 10px 8px 10px;
	background: #364756;
	border: 1px solid rgba(255, 255, 255, 0.14);
	border-radius: 10px;
	box-shadow: 0 6px 20px rgba(0,0,0,0.3);
	padding: 8px 0;
	overflow: hidden;
}

.sidebar-footer-user.dropup-open {
	background: rgba(122, 155, 184, 0.2);
}

.sidebar-footer-chevron.arrow-rotated {
	transform: rotate(180deg);
	color: #75CBDD;
}

.sidebar-footer-org-list::-webkit-scrollbar,
.sidebar-footer-user-dropup-flow::-webkit-scrollbar {
	width: 4px;
}

.sidebar-footer-org-list::-webkit-scrollbar-track,
.sidebar-footer-user-dropup-flow::-webkit-scrollbar-track {
	background: transparent;
}

.sidebar-footer-org-list::-webkit-scrollbar-thumb,
.sidebar-footer-user-dropup-flow::-webkit-scrollbar-thumb {
	background: rgba(255,255,255,0.15);
	border-radius: 4px;
}

/* ── Org Flyout Transition (to the RIGHT) ── */
.footer-flyout-enter-active {
	transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
}

.footer-flyout-leave-active {
	transition: all 0.15s cubic-bezier(0.4, 0, 1, 1);
}

.footer-flyout-enter-from {
	opacity: 0;
	transform: translateX(-10px) scale(0.97);
}

.footer-flyout-leave-to {
	opacity: 0;
	transform: translateX(-6px) scale(0.98);
}

/* ── User Dropup Flow Transition (Smooth Accordion Push Up) ── */
.user-dropup-flow-enter-active {
	transition: max-height 0.25s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.2s ease, transform 0.25s cubic-bezier(0.16, 1, 0.3, 1), margin 0.25s ease, padding 0.25s ease;
	max-height: 220px;
}

.user-dropup-flow-leave-active {
	transition: max-height 0.2s cubic-bezier(0.4, 0, 1, 1), opacity 0.15s ease, transform 0.2s cubic-bezier(0.4, 0, 1, 1), margin 0.2s ease, padding 0.2s ease;
	max-height: 220px;
}

.user-dropup-flow-enter-from,
.user-dropup-flow-leave-to {
	opacity: 0;
	max-height: 0;
	margin-top: 0;
	margin-bottom: 0;
	padding-top: 0;
	padding-bottom: 0;
	transform: translateY(6px);
}


/* ═══════════════════════════════════════════════
   COLLAPSED FOOTER
   ═══════════════════════════════════════════════ */

.collapsed-account {
	display: none;
	flex-direction: column;
	align-items: center;
	position: relative;
}

.sidebar-container.active .collapsed-account {
	display: flex;
}

.sidebar-container.active .expanded-account {
	display: none;
}

.collapsed-icon-wrapper {
	position: relative;
	margin-bottom: 6px;
	display: flex;
	justify-content: center;
}

.collapsed-flyout-pos {
	position: absolute !important;
	left: calc(100% + 12px) !important;
	bottom: -4px !important;
	margin: 0 !important;
}

.collapsed-user-menu {
	width: 240px !important;
}

.user-flyout-header {
	padding: 4px 14px 10px;
}

.collapsed-user-header-info {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 2px;
}

.collapsed-user-header-name {
	font-size: 13px;
	font-weight: 700;
	color: #ffffff;
	letter-spacing: 0.3px;
	line-height: 1.3;
}

.collapsed-icon-btn.active-btn .collapsed-org-logo,
.collapsed-icon-btn.active-btn .collapsed-user-avatar {
	border-color: #75CBDD !important;
	box-shadow: 0 0 10px rgba(117, 203, 221, 0.4);
}

/* ── Collapsed Tooltip ── */
.collapsed-user-tooltip {
	position: relative;
}

.collapsed-user-tooltip::after {
	content: attr(data-tooltip);
	position: absolute;
	left: calc(100% + 10px);
	top: 50%;
	transform: translateY(-50%);
	background: #364756;
	color: #fff;
	font-size: 11px;
	font-weight: 500;
	padding: 5px 10px;
	border-radius: 6px;
	white-space: nowrap;
	pointer-events: none;
	opacity: 0;
	transition: opacity 0.2s ease;
	box-shadow: 0 4px 12px rgba(0,0,0,0.3);
	z-index: 1060;
}

.collapsed-user-tooltip::before {
	content: '';
	position: absolute;
	left: calc(100% + 4px);
	top: 50%;
	transform: translateY(-50%);
	border: 5px solid transparent;
	border-right-color: #364756;
	pointer-events: none;
	opacity: 0;
	transition: opacity 0.2s ease;
	z-index: 1060;
}

.collapsed-user-tooltip:hover::after,
.collapsed-user-tooltip:hover::before {
	opacity: 1;
}

/* Hide tooltip when flyout is open */
.collapsed-icon-btn.active-btn::after,
.collapsed-icon-btn.active-btn::before {
	display: none !important;
}

/* ── Collapsed Logout Button ── */
.collapsed-logout-btn {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 32px;
	height: 32px;
	margin: 2px auto 6px;
	border-radius: 8px;
	color: #6c8ca0;
	font-size: 13px;
	cursor: pointer;
	transition: color 0.2s, background-color 0.2s, opacity 0.2s;
	opacity: 0.8;
}

.collapsed-account:hover .collapsed-logout-btn {
	opacity: 1;
}

.collapsed-logout-btn:hover {
	color: #ff6b6b;
	background-color: rgba(255, 107, 107, 0.15);
}
</style>